import { useState, useEffect } from "react";
import axios from "axios";
import { Button } from "@/components/ui/button";
import { RefreshCw, AlertTriangle } from "lucide-react";
import { APP_VERSION } from "@/version";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

const compareVersions = (v1, v2) => {
  const a = v1.split(".").map(Number);
  const b = v2.split(".").map(Number);
  for (let i = 0; i < Math.max(a.length, b.length); i++) {
    const p1 = a[i] || 0;
    const p2 = b[i] || 0;
    if (p1 > p2) return 1;
    if (p1 < p2) return -1;
  }
  return 0;
};

const getStoreInfo = (platform) => {
  if (platform === "android") {
    return { url: "https://play.google.com/store/apps/details?id=it.feriepermessi.app", label: "Google Play" };
  }
  return { url: "https://apps.apple.com/it/app/id6762294169", label: "App Store" };
};

export const ForceUpdateGate = () => {
  const [blocked, setBlocked] = useState(false);
  const [minVersion, setMinVersion] = useState("");
  const platform = window.Capacitor?.getPlatform?.();
  const isNativeApp = platform === "android" || platform === "ios";

  useEffect(() => {
    if (!isNativeApp) return;
    axios
      .get(`${BACKEND}/api/version`)
      .then((res) => {
        const min = res.data?.min_app_version;
        if (min && compareVersions(APP_VERSION, min) < 0) {
          setMinVersion(min);
          setBlocked(true);
        }
      })
      .catch(() => {});
  }, [isNativeApp]);

  if (!blocked) return null;

  const store = getStoreInfo(platform);

  return (
    <div className="fixed inset-0 z-[9999] bg-slate-900/95 flex items-center justify-center p-6" data-testid="force-update-overlay">
      <div className="bg-white rounded-2xl shadow-2xl max-w-sm w-full p-6 text-center space-y-4">
        <div className="mx-auto h-14 w-14 rounded-full bg-amber-100 flex items-center justify-center">
          <AlertTriangle className="h-7 w-7 text-amber-500" />
        </div>
        <h2 className="text-xl font-bold text-slate-900">Aggiornamento necessario</h2>
        <p className="text-sm text-slate-600">
          Questa versione dell'app ({APP_VERSION}) non è più supportata.
          Aggiorna alla versione {minVersion} o successiva per continuare a usare Ferie e Permessi.
        </p>
        <Button
          onClick={() => window.open(store.url, "_blank")}
          className="w-full h-12 bg-slate-900 hover:bg-slate-800 text-white gap-2"
          data-testid="force-update-store-btn"
        >
          <RefreshCw className="h-4 w-4" />
          Aggiorna da {store.label}
        </Button>
        <p className="text-xs text-slate-400">
          Dopo l'aggiornamento riapri l'app: tornerà tutto come prima.
        </p>
      </div>
    </div>
  );
};
